import normalizeWheel from 'normalize-wheel'
import i18n from '@/i18n'
import { lerp } from '@/js/utils'

function vfont (settings) {
  let css = []
  Object.keys(settings).forEach(settingKey => {
    css.push(`'${settingKey}' ${settings[settingKey]}`)
  })
  return css.join(',')
}

export default function (parentEl, start) {
  const n = 7
  const sentence = i18n.t('look_further')
  // const startTime = Date.now()
  let wheel = 0
  let control = 0
  window.addEventListener('wheel', e => { wheel += Math.min(normalizeWheel(e).pixelY, 100) })

  parentEl.style.display = 'flex'
  parentEl.style.alignItems = 'center'
  parentEl.style.justifyContent = 'center'

  const div = { el: document.createElement('div'), ps: Array(n).fill({}) }
  div.el.style.color = 'var(--white)'
  div.el.style.fontFamily = 'var(--font-v)'
  div.el.style.textAlign = 'center'
  div.el.style.fontSize = '5vw'
  div.el.style.lineHeight = '1'

  div.ps = div.ps.map(() => {
    const p = { el: document.createElement('p'), settings: { wdth: 125, wght: 500 } }
    p.el.style.margin = 0
    p.el.textContent = sentence
    return p
  })

  div.el.append(...div.ps.map(p => p.el))
  parentEl.append(div.el)

  start()

  // draw each frame
  return function () {
    // control = Date.now() - startTime
    control = lerp(control, wheel, 0.08)

    div.ps.forEach((p, i) => {
      const val = (Math.sin(i / n * 5 + control / 300) + 1) / 2

      p.settings = {
        wght: lerp(150, 800, val),
        wdth: lerp(110, 125, val)
      }

      p.el.style.fontVariationSettings = vfont(p.settings)
    })
  }
}
